export default {
  downloadPlural: 'Cкачать исходные файлы',
  uploadPlural: 'Загрузить исходные файлы'
};
